import React from 'react';
import OGCreateTeacherView from '../domains/creative/components/OGCreateTeacherView';

const OGCreateTeacherPage: React.FC = () => {
  return <OGCreateTeacherView />;
};

export default OGCreateTeacherPage;


